class ReadMore extends HTMLElement {
    constructor() {
        super();
        this.toggleButton = this.querySelector('.trigger');
        this.contentElement = this.querySelector('.js-read-more .js-read-more--text');
        this.enableReadLess = this.getAttribute('enable-read-less');
        this.forceShowMore = this.contentElement.dataset.forceShowMore;
        this.longText = this.querySelector('[data-long-content]');
        this.truncatedText = this.querySelector('[data-short-content]');
        this.listener();
    }

    connectedCallback() {
        this.checkIfClamped();
    }
    checkHeight() {
        if (this.contentElement.scrollHeight > this.contentElement.clientHeight) {
            this.toggleButton.classList.remove('tw-hidden');
        }
    }

    listener() {
        this.toggleButton.addEventListener("click", () => {
            this.toggleText();

        });
        this.toggleButton.addEventListener("keydown", (e) => {
            if(e.keyCode == ENTER_KEY_CODE){
                this.toggleText();
            }
        });
    }
    
    toggleText() {
        const isLong = this.dataset.content === 'long';
        const forceShowMoreTrue = this.forceShowMore === "true";

        if (!this.forceShowMore) {
            this.contentElement.classList.toggle("tw-line-clamp-2", isLong);
        }
        console.log('isLong',isLong);
        if (isLong) {
            this.toggleButton.querySelector("span").innerText = this.toggleButton.getAttribute('text-more');
            this.setAttribute('data-content', 'short');
        } else {
            if (this.enableReadLess !== "false") {
                this.toggleButton.querySelector("span").innerText = this.toggleButton.getAttribute('text-less');
            }
            this.setAttribute('data-content', 'long');
        }

        if (this.forceShowMore) {
            if (isLong) {
                if (forceShowMoreTrue) {
                    this.longText.classList.add('tw-hidden');
                    this.truncatedText.classList.remove('tw-hidden');
                } else {
                    this.longText.classList.remove('tw-hidden');
                    this.truncatedText.classList.add('tw-hidden');
                }
            } else {
                if (forceShowMoreTrue) {
                    this.longText.classList.remove('tw-hidden');
                    this.truncatedText.classList.add('tw-hidden');
                } else {
                    this.longText.classList.add('tw-hidden');
                    this.truncatedText.classList.remove('tw-hidden');
                }
            }
        }
    }

    checkIfClamped() {
        
        if (this.forceShowMore) {
            this.toggleButton.classList.toggle('tw-hidden', !this.forceShowMore);
            this.longText.classList.toggle('tw-hidden', this.forceShowMore);
            this.truncatedText.classList.toggle('tw-hidden', !this.forceShowMore);
        } else {

            this.contentElement.classList.remove('tw-line-clamp-2');
            const fullHeight = this.contentElement.scrollHeight;
            this.contentElement.classList.add('tw-line-clamp-2');
            const clampedHeight = this.contentElement.offsetHeight;
            const forceShowMoreTrue = this.forceShowMore === "true";

            const isClamped = fullHeight > clampedHeight;
            this.toggleButton.classList.toggle('tw-hidden', !isClamped);
        }
    }

    
}  
customElements.define('read-more', ReadMore);